import { ActionButton } from "@fluentui/react";
import { Utils } from "../../common/views/Utils";
import { AccountProvider } from "../models/AccountTypes";

type AccountOptionProps = {
    title: string;
    provider: AccountProvider;
    setProvider: (provider: AccountProvider) => void;
}

export function AccountOptionView({ title, provider, setProvider }: AccountOptionProps) {
    const width4 = Utils.getColumnWidth(4);
    const width8 = Utils.getColumnWidth(8);

    const isByEmail = () => { return provider === AccountProvider.email; }

    const phoneButton = () => {
        return <ActionButton
            onClick={() => setProvider(AccountProvider.phone)}
            iconProps={{ iconName: "Phone" }}
        >
            <span style={{ textDecoration: "underline", color: !isByEmail() ? "black" : "gray" }}>
                By Phone
            </span>
        </ActionButton>;
    }

    const emailButton = () => {
        return <ActionButton
            onClick={() => setProvider(AccountProvider.email)}
            iconProps={{ iconName: "Mail" }}
            style={{ paddingLeft: 20 }}
        >
            <span style={{ textDecoration: "underline", color: isByEmail() ? "black" : "gray" }}>
                By Email
            </span>
        </ActionButton>;
    }

    return <div className="ms-Grid-row pv-5 ph-15">
        <div className={width4 + " left font-title"} style={{ paddingTop: 8 }}>
            {title}
        </div>

        <div className={width8 + " right"}>
            {phoneButton()}
            {emailButton()}
        </div>
    </div>
}